import {makeStyles} from '@material-ui/core';
import {Colors} from '../../../styles/Colors';
import i18n from '../../../services/i18n';
import * as Yup from 'yup';
import dayjs from '../../../services/customDayJs';
import {convertFormatFromBackendToDayJs} from '../../../utils/dateWithTimezoneConversion';
import {notPastDateTest} from '../../../utils/notPastDateTest';

export const useStyles = makeStyles(() => ({
    itemsContainer: {
        padding: '18px 24px',
        display: 'flex',
        flexDirection: 'column',

        '& .MuiFormControl-root': {
            marginBottom: 24,
        },
    },
    header: {
        '& .MuiTypography-h6': {
            fontWeight: 'bold',
            fontSize: 18,
        },
    },
    modalContainer: {
        '& .MuiDialogContent-root': {
            width: 520,
            padding: '28px 60px',
            backgroundColor: Colors.SmokeBackground,
        },
    },
}));

const required = i18n.t('errors:common.emptyInput');

export const accountIdMaxLength = 64;
export const accountEmailMaxLength = 128;

export const makeAddAccountValidationSchema = (userDateFormat: string) =>
    Yup.object().shape({
        accountId: Yup.string().max(accountIdMaxLength).required(required),
        email: Yup.string().max(accountEmailMaxLength).email(i18n.t('errors:common.invalidEmail')).nullable(),
        mainProductId: Yup.number().required(required).typeError(required),
        activationDate: Yup.string()
            .test(
                'past',
                notPastDateTest(
                    'errors:accounts.activationDate',
                    () => dayjs(),
                    () => dayjs().format(convertFormatFromBackendToDayJs(userDateFormat || 'YYYY-MM-DD')),
                ),
            )
            .nullable(),
    });

export type AddNewAccountFormValues = {
    accountId: string;
    email: string;
    mainProductId: number | undefined;
    activationDate: string | null;
};

export const initialValues: AddNewAccountFormValues = {
    accountId: '',
    email: '',
    mainProductId: undefined,
    activationDate: null,
};
